import { config } from '@uhg-abyss/web/tools/config';

type Feature = {
  SUB_FEATURES?: Feature[];
  ENABLED: boolean;
};

export type Features = {
  UNITEUS_API: Feature;
  CLOSE_THE_LOOP: Feature;
  EMAIL: Feature;
  FAVORITES: Feature;
  BULK_REFER: Feature;
  LOG_A_BENEFIT: Feature;
};

export function getFeatureFlags(): Features {
  const feat = config('FEATURES') as any;

  if (!isFeatureFlags(feat)) {
    console.error("Feature flags from config did not align with expected type. This is a programmer error."
      + " Please check the config file and ensure that the feature flags are correctly defined,"
      + " and that the type of `Features` in `features.ts` follows the shape of the data in the JSON file.");
  }

  return feat as Features;
}

function isFeatureFlags(value: unknown): value is Features {
  return (
      typeof value === 'object' &&
      value !== null &&
      'UNITEUS_API' in value &&
      'CLOSE_THE_LOOP' in value &&
      'EMAIL' in value &&
      'FAVORITES' in value &&
      'BULK_REFER' in value &&
      'LOG_A_BENEFIT' in value &&
      typeof value['UNITEUS_API'] === 'object' &&
      typeof value['CLOSE_THE_LOOP'] === 'object' &&
      typeof value['EMAIL'] === 'object' &&
      typeof value['FAVORITES'] === 'object' &&
      typeof value['BULK_REFER'] === 'object' &&
      typeof value['LOG_A_BENEFIT'] === 'object' &&
      typeof value['UNITEUS_API']['ENABLED'] === 'boolean' &&
      typeof value['CLOSE_THE_LOOP']['ENABLED'] === 'boolean' &&
      typeof value['EMAIL']['ENABLED'] === 'boolean' &&
      typeof value['FAVORITES']['ENABLED'] === 'boolean' &&
      typeof value['BULK_REFER']['ENABLED'] === 'boolean' &&
      typeof value['LOG_A_BENEFIT']['ENABLED'] === 'boolean'
  );
}

